const Joi = require('joi');


const buildingData = Joi.object({
  buildingStreet: Joi.string().trim().required().messages({
    'string.empty': 'errors.building.street.required',
    'any.required': 'errors.building.street.required'
  }),

  buildingHouseNumber: Joi.string().trim().required().messages({
    'string.empty': 'errors.building.houseNumber.required',
    'any.required': 'errors.building.houseNumber.required'
  }),

  buildingPostalCodeNumber: Joi.string().trim().required().messages({
    'string.empty': 'errors.building.postalCode.required',
    'string.pattern.base': 'errors.building.postalCode.invalid',
    'any.required': 'errors.building.postalCode.required'
  }),

  buildingCity: Joi.string().trim().required().messages({
    'string.empty': 'errors.building.city.required',
    'any.required': 'errors.building.city.required'
  }),

  buildingCountry: Joi.string().trim().required().messages({
    'string.empty': 'errors.building.country.required',
    'any.required': 'errors.building.country.required'
  })
})

module.exports = buildingData